module.exports = __webpack_public_path__ + "static/media/Flechas-27.f7149cda.svg";